import _ from "lodash";

class StoreModule {
	constructor(
		name,
		mutations,
		actions,
		getters,
		initial_state = {},
		additional_mutation_names = {},
		additional_action_names = {}
	) {
		this.MODULE_NAME = name;
		this.MUTATION_TYPES = Object.assign(
			_.mapValues(mutations, (m, k) => k),
			additional_mutation_names
		);
		this.ACTION_TYPES = Object.assign(
			_.mapValues(actions, (m, k) => k),
			additional_action_names
		);

		this.namespaced = true;

		this.state = initial_state;
		this.mutations = mutations;
		this.actions = actions;
		this.getters = getters;
	}
}

export default StoreModule;
